import { ConditionValueInputComponent } from 'Automations/nodeDefinitions/conditions'
import { UserSelector } from './components/UserSelector'

export const UserValueInput: ConditionValueInputComponent = ({
  'data-testid': dataTestId,
  value,
  onChange,
  validationErrors
}) => (
  <UserSelector
    data-testid={dataTestId ? `${dataTestId}.value` : undefined}
    values={value}
    onChange={next => onChange({ value: next })}
    validationErrors={validationErrors}
  />
)
